// frontend/src/pages/CustomerOverview.tsx
import React from 'react';

const CustomerOverview: React.FC = () => {
  return (
    <div className="p-6">
      <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded mb-4">
        <p className="font-bold">
          🎉 Success! Customer Account Layout is working!
        </p>
      </div>
      <h1 className="text-2xl font-bold mb-4">Account Overview</h1>
      <p>Welcome to your customer account dashboard.</p>
    </div>
  );
};

export default CustomerOverview;